import axios from 'axios';
import qs from 'qs';
import { Message } from 'element-ui';
import bowser from 'bowser';

const baseURL = process.env.NODE_ENV === 'development'
  ? 'http://api.weiji.cn'
  : 'https://api.wjid.com.cn';
axios.defaults.baseURL = baseURL;

const service = axios.create({
  baseURL,
  timeout: 8000,
});

service.interceptors.request.use(
  (config) => {
    const tempConfig = config;
    tempConfig.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    if (tempConfig.method === 'post') {
      tempConfig.data = qs.stringify(tempConfig.data);
    }
    // 当前设备
    tempConfig.headers.Dev = bowser.mobile ? 'wap' : 'web';
    return tempConfig;
  },
  (error) => {
    console.error(error);
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.status !== 0) {
      const message = res.error instanceof Array ? res.error.join('\r\n') : res.error;
      Message({
        message,
        type: 'error',
        duration: 3 * 1000,
      });
      return Promise.reject(new Error(message) || 'Error');
    }
    return res;
  },
  (error) => {
    console.error(`err${error}`);
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000,
    });
    return Promise.reject(error);
  },
);

export default service;
